import { makeRequest } from '../../../api/makeRequest';

export const saveLimits = (limits) => makeRequest({
  url: '/limitFamily/updateChildLimits/',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  method: 'put',
  data: limits,
});
